import { Button } from "@components/Button";
import { Drawer } from "@components/Drawer";
import { Hairline } from "@components/Hairline";
import { Label } from "@components/Label";
import { Radio } from "@components/Radio";
import { ForEach } from "@components/control-statements";
import { useState } from "react";

import styles from "@styles/pages/cdp/customers.module.scss";

import { BaseCurrencyInput } from "@components";
import { Numbers } from "@utils/Numbers";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const SORT_TAGS = [
  { name: "Último pedido mais recente", value: "LAST_ORDER_DESC" },
  { name: "Último pedido mais antigo", value: "LAST_ORDER_ASC" },
  { name: "Menor total gasto", value: "SPEND_VALUE_ASC" },
  { name: "Maior total gasto", value: "SPEND_VALUE_DESC" },
  { name: "Menor nº de pedidos", value: "ORDER_QUANTITY_ASC" },
  { name: "Maior nº de pedidos", value: "ORDER_QUANTITY_DESC" },
  { name: "Menor ticket médio", value: "AVERAGE_TICKET_ASC" },
  { name: "Maior ticket médio", value: "AVERAGE_TICKET_DESC" },
  { name: "Menor recência", value: "RECENCY_ASC" },
  { name: "Maior recência", value: "RECENCY_DESC" },
  { name: "Menor frequência", value: "FREQUENCY_ASC" },
  { name: "Maior frequência", value: "FREQUENCY_DESC" },
];

export const sortLabel = (sort) => {
  const sort_tag = SORT_TAGS.find(
    (s) => s.value == (sort || "LAST_ORDER_DESC")
  );
  return sort_tag.name;
};

export const limitLabel = (limit) => {
  const type = limitTypeByNumber(limit);
  switch (type) {
    case "NO_LIMIT":
      return "Sem limitação";
    default:
      return `${Numbers.formatInt(limit || 0)} registros`;
  }
};

export const limitTypeByNumber = (limit_number) => {
  const defaults = [10, 20, 50, 100, 500, 1000];
  if (defaults.includes(limit_number)) {
    return limit_number;
  } else if (!limit_number) {
    return "NO_LIMIT";
  } else {
    return "CUSTOM";
  }
};

const limitNumberByType = (limit_type, custom) => {
  const defaults = [10, 20, 50, 100, 500, 1000];
  if (defaults.includes(limit_type)) {
    return limit_type;
  } else if (limit_type == "NO_LIMIT") {
    return null;
  } else {
    return custom;
  }
};

export default function OrderingAndLimitation({
  selected,
  visible,
  onSave,
  onClose,
}) {
  const { sort, limit } = selected || {};
  const limit_type = limitTypeByNumber(limit);

  const [ordering, setOrdering] = useState(sort || "LAST_ORDER_DESC");
  const [limitation, setLimitation] = useState(limit_type);
  const [customLimitation, setCustomLimitation] = useState(
    limit_type == "CUSTOM" ? limit : null
  );

  return (
    <Drawer
      title="Ordenação e Limitação"
      showCloseButton
      visible={visible}
      onClose={onClose}
    >
      <div className={styles.orderingAndLimitationScroll}>
        <div className={styles.box}>
          <Label>Defina a ordenação:</Label>
          <div className={styles.orderingTags}>
            <ForEach
              items={SORT_TAGS || []}
              render={(tag) => (
                <div
                  className={css({
                    tag: true,
                    selected: ordering === tag.value,
                  })}
                  onClick={() =>
                    setOrdering(ordering === tag.value ? null : tag.value)
                  }
                >
                  <span>{tag.name}</span>
                </div>
              )}
            />
          </div>
        </div>

        <Hairline solid className="mt-20 mb-20" />

        <div className={styles.box}>
          <Label>Defina a limitação do resultado</Label>

          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value="NO_LIMIT"
            onChange={() => setLimitation("NO_LIMIT")}
          >
            Sem limitação
          </Radio>

          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={10}
            onChange={() => setLimitation(10)}
          >
            10
          </Radio>
          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={20}
            onChange={() => setLimitation(20)}
          >
            20
          </Radio>
          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={50}
            onChange={() => setLimitation(50)}
          >
            50
          </Radio>
          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={100}
            onChange={() => setLimitation(100)}
          >
            100
          </Radio>
          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={500}
            onChange={() => setLimitation(500)}
          >
            500
          </Radio>
          <Radio
            className="mb-10"
            family="limitation"
            checked={limitation}
            value={1000}
            onChange={() => setLimitation(1000)}
          >
            1000
          </Radio>
          <Radio
            family="limitation"
            checked={limitation}
            value="CUSTOM"
            onChange={() => setLimitation("CUSTOM")}
          >
            Personalizado
          </Radio>

          {limitation === "CUSTOM" && (
            <BaseCurrencyInput
              className="mt-10 mb-0"
              precision={0}
              prefix=""
              value={customLimitation}
              onChange={(e) => setCustomLimitation(e)}
            />
          )}
        </div>
        <div className={styles.footer}>
          <Button
            className="w-100"
            onClick={() => {
              const payload = {
                sort: ordering || null,
                limit: limitNumberByType(limitation, customLimitation),
              };
              onSave && onSave(payload);
            }}
            disabled={
              !ordering ||
              !limitation ||
              (limitation === "CUSTOM" && !customLimitation)
            }
            design="primary"
          >
            Salvar
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
